import { createStore } from 'vuex';

const store = createStore({
  state: {
    formData: {
    },
    settingData: {
      hasReadPrivacyPolicy: false,
      hasReadTerms: false,
      isAuthenticated: false,
      selectedKeys: {},
      options: {}
    }
  },
  mutations: {
    setFormData(state, data) {
      state.formData = data;
    },
    updateFormData(state, payload) {
      state.formData = { ...state.formData, ...payload };
    },
    setSettingData(state, data) {
      state.settingData = { ...state.settingData, ...data };
    },
    updateSettingData(state, payload) {
      state.settingData = { ...state.settingData, ...payload };
    },
    setSelectOptions(state, { key, options }) {
      state.settingData.options[key] = options;
    },
    setSelectedKey(state, { key, selectedKey }) {
      state.settingData.selectedKeys[key] = selectedKey;
    },
    setRadioOptions(state, { key, options }) {
      state.settingData.options[key] = options;
    },
    setSelectedRadio(state, { key, selectedKey }) {
      state.settingData.selectedKeys[key] = selectedKey;
    }
  }
});

export default store;
